import React from "react";

import "./styles.scss";

const Select = ({ input, options, appendEmptyOption, ...etc }) => (
  <div className="input">
    <select {...input} {...etc}>
      {appendEmptyOption === true && (
        <option value="" key={-1}>
          Seleccionar opción
        </option>
      )}
      {options.map((option, i) => {
        let value, label;

        if (option === null) {
          value = "";
          label = "Seleccionar opción";
        } else {
          label =
            typeof option != "object" ? option : option.label || option.name;
          value =
            typeof option != "object"
              ? option
              : option.value || option.id || label;
        }

        return (
          <option value={value} key={i}>
            {label}
          </option>
        );
      })}
    </select>
  </div>
);

export default Select;
